import { forwardRef, useContext, useMemo, useEffect, useImperativeHandle } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppThemeContext } from "../../contexts/colors";
import { localeContext } from "../../contexts/localeManagement";

import Modal from '@mui/material/Modal';
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import { useStateCallback } from "../../utils/stateCallback";

export default forwardRef(function BottomPopupModal({
	modalVisible = true,
	setModalVisible = () => {},
	modalTitle,
	colorPrimary = "",
	colorSecondary = "",
	xVisible = true,
	closeResult = () => {},
	children
}, ref) {
	const {
		dark,
		colors
	} = useContext(AppThemeContext);
	const [ top, setTop ] = useStateCallback(window.innerHeight);
	const animDurations = useMemo(() => 500, []);
	const { locale, appText } = useContext(localeContext);

	useEffect(() => {
		if (modalVisible) {
			setTimeout(() => {
				setTop("30%")
			}, 500);
		}
	}, [modalVisible]);

	let modalStyles = useMemo(() => ({
		dropdownBtnIcon: {
			position: "absolute",
			top: "40px",
			right: "30px",
			cursor: "pointer"
		},
		modalContainer: {
			display: "flex",
			flexDirection: "column",
			flex: 1,
			justifyContent: 'flex-end',
			alignItems: 'center',
			backgroundColor: colors().constantBlack + "88"
		},
		modalContent: {
			display: "flex",
			flexDirection: "column",
			backgroundColor: colorSecondary ? colorSecondary : dark ? colors().screen : colors().primary,
			padding: 25,
			justifyContent: 'center',
			shadowColor: '#000',
			shadowOffset: {
				width: 0,
				height: 0,
			},
			shadowOpacity: 0.25,
			shadowRadius: 4,
			elevation: 5,
			height: "52vh"
		},
		modalText: {
			display: "flex",
			flexDirection: "column",
			color: colors().constantWhite,
			fontWeight: "bold",
			fontSize: 30,
			fontFamily: "monospace",
			textAlign: "center"
		},
		modalHeader: {
			display: "flex",
			flexDirection: "column",
			backgroundColor: colorPrimary ? colorPrimary : dark ? colors().gray : colors().secondary,
			padding: 20,
			paddingTop: 10,
			borderTopLeftRadius: 20,
			borderTopRightRadius: 20
		},
		modalFooter: {
			display: "flex",
			flexDirection: "column",
			backgroundColor: colorPrimary ? colorPrimary : dark ? colors().gray : colors().secondary,
			padding: 20,
			paddingVertical: 10,
			width: "100%"
		},
		modalHeaderText: {
			display: "flex",
			flexDirection: "column",
			color: colors().constantWhite,
			fontFamily: locale === "ar" ? "ArabicMainBold" : "",
			fontWeight: locale === "ar"
				? "regular"
				: "bold",
			textAlign: "center",
			fontSize: 30
		}
	}), [dark, colorPrimary, colorSecondary, locale])

	//^ Close Functions
	const closeModal = () => {
		setTop(window.innerHeight, () => {
			setTimeout(() => {
				setModalVisible(!modalVisible);
				closeResult();
			}, 700);
		});
	}

	const cancel = () => {
		setTop(window.innerHeight, () => {
			setTimeout(() => {
				setModalVisible(!modalVisible);
			}, 700);
		});
	}

	useImperativeHandle(ref, () => ({
		cancelModal: cancel,
		closeModal
	}));

	return (
		<>
			<Modal
				open={modalVisible}
				onClose={closeModal}
			>
				<div style={modalStyles.modalContainer}>
						<div style={{ position: "absolute", width: "100%", transition: "all 500ms ease-out", top }}>
							<div style={modalStyles.modalHeader}>
								<div
									style={{
										backgroundColor: colors().mawjoodOther,
										width: 50,
										height: 5,
										borderRadius: 5,
										marginRight: "auto",
										marginLeft: "auto",
										marginBottom: 5
									}}
								/>
								<h1 style={modalStyles.modalHeaderText}>{appText[modalTitle] || modalTitle}</h1>
								{xVisible ? <div>
									<FontAwesomeIcon icon={faXmark} size={"3x"} color={colors().constantWhite} style={modalStyles.dropdownBtnIcon}
										onClick={cancel}
									/>
								</div> : null}
							</div>
							<div style={modalStyles.modalContent}>
								{children}
							</div>
						</div>
				</div>
			</Modal>
		</>
	);
})